// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5K6XznHhH_H4CG9HtjjVl"};